import { render, staticRenderFns } from "./widgetFwGeoAllowTrafficTopn.vue?vue&type=template&id=2626406b&scoped=true&"
import script from "./widgetFwGeoAllowTrafficTopn.vue?vue&type=script&lang=js&"
export * from "./widgetFwGeoAllowTrafficTopn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2626406b",
  null
  
)

export default component.exports